import { rest } from 'utils';

export default {
  create: ({ name, password, email }) => rest.post({ url: '/backupunits', body: { properties: { name, password, email } } }),
  get: ({ id }) => rest.get({ url: `/backupunits/${id}` }),
  getAll: () => rest.get({ url: '/backupunits?depth=4' }),
  update: ({
    name, password, email, id,
  }) => rest.put({ url: `/backupunits/${id}`, body: { properties: { name, password, email } } }),
  delete: ({ id }) => rest.delete({ url: `/backupunits/${id}` }),
  getSsoUrl: ({ backupUnitId }) => rest.get({ url: `/backupunits/${backupUnitId}/ssourl` }),
};
